import React from 'react'

import { useFilterPosts } from '../../hooks/useFilterPosts'
import { PostsFilterView } from './PostsFilterView'
import { FILTER_TYPE_LABELS } from './consts'
import type { FilterFormValues } from './types'
import { mapLabelsToCheckboxOptions } from './utils'

export const PostsFilterContainer = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } = useFilterPosts()

  const handleSubmit = (values: FilterFormValues) => {
    setFiltersParams({
      types: values.types.length ? values.types.join(',') : undefined,
    })
  }

  const getInitialValues = () => ({
    types: filtersParams.types ? filtersParams.types.split(',') : [],
  })

  return (
    <PostsFilterView
      initialValues={getInitialValues()}
      types={mapLabelsToCheckboxOptions(FILTER_TYPE_LABELS)}
      filterActive={hasFilterParams}
      onSubmit={handleSubmit}
      onReset={resetFiltersParams}
    />
  )
}
